'use strict';

// TODO: Review this when all payment go through Stripe.

/**
* This file was created to provide functionality and business logic for Credit and SRC payment methods. Do not expand this file!
* Changes and additions to the code should be made to the appropriate files in the folders, depending on the payment method required, to maintain a clear code architecture.
*/

var loaderInstance = require('braintree/braintree/loaderHelper');
var ErrorHandlingBaseModel = require('braintree/braintree/creditcard/errorhandler/errorHandlingBaseModel');

var errorHandlingBaseModel = new ErrorHandlingBaseModel();
var creditCardListLoader;

/**
* Shows the new card block on the Account Page
*/
function showAddNewCardOptions() {
    var $addNewCardButton = document.querySelector('.braintreeAddNewCard');
    var $addNewCardBlock = document.querySelector('.braintreeAddNewCardBlock');

    // Hide "Credit Card error message" container
    errorHandlingBaseModel.hideError();
    // Hide "Add New Card" button
    $addNewCardButton.style.display = 'none';
    // Display "Add New Card" form
    $addNewCardBlock.style.display = 'block';
}

/**
 * Parses data-is-remove-allowed; missing/invalid values default to allowed.
 * @param {Element} target Confirm button
 * @returns {boolean} Whether removal is allowed
 */
function isRemovePaymentAllowed(target) {
    var attrValue = target && target.getAttribute('data-is-remove-allowed');

    if (attrValue === null || attrValue === '' || attrValue === 'undefined') {
        return true;
    }

    try {
        return Boolean(JSON.parse(attrValue));
    } catch (err) {
        return true;
    }
}

/**
 * Removes card from Credit/SRC Cards list
 * @param {Object} e Event object
 */
function removeCard(e) {
    var target = e.currentTarget || e.target;

    if (target && isRemovePaymentAllowed(target)) {
        // Stripe changes BEGIN
        if (creditCardListLoader) {
            creditCardListLoader.show();
        }
        // Stripe changes END

        $.get(target.getAttribute('data-url') + '?UUID=' + target.getAttribute('data-id'))
            .then((data => {
                $('#uuid-' + data.UUID).remove();

                if (data.newDefaultAccount) {
                    document.querySelector('#uuid-' + data.newDefaultAccount + ' span').style.fontWeight = 'bold';
                    document.querySelector('#uuid-' + data.newDefaultAccount + ' button.braintree-make-default-card').style.display = 'none';
                }

                if (($('.creditCard-accounts').length == 0 || $('.creditCard-accounts').children().length == 0)
                    &&
                    ($('.paypal-accounts').length == 0 || $('.paypal-accounts').children().length == 0)) {
                    $('.payment-methods-list').addClass('d-none');
                    $('.payment-methods-empty').removeClass('d-none');
                }

                // Stripe changes BEGIN
                if (creditCardListLoader) {
                    creditCardListLoader.hide();
                }
                // Stripe changes END
            }))
            .fail(() => {
                location.reload();
            });
    } else {
        var removeErrorMessage = target.getAttribute('data-message-remove-is-not-allowed');
        errorHandlingBaseModel.showErrorByMessage(removeErrorMessage);
    }
}


/**
 * Resets delete payment modal to default (confirm delete) content.
 */
function resetDeletePaymentModal() {
    var $modal = $('#deletePaymentModal');

    $modal.find('.js-delete-payment-modal-title-default').removeClass('d-none');
    $modal.find('.js-delete-payment-modal-title-in-use').addClass('d-none');
    $modal.find('.js-delete-payment-modal-msg-default').removeClass('d-none');
    $modal.find('.js-delete-payment-modal-msg-in-use').addClass('d-none');
    $modal.find('.js-delete-payment-modal-confirm').removeClass('d-none');
    $modal.find('.js-delete-payment-modal-subscription-link')
        .addClass('d-none')
        .attr('href', '#');
}

/**
 * Shows delete modal when payment method is linked to an active subscription.
 * @param {string} manageUrl - subscription manage URL
 */
function setDeletePaymentModalInUseMode(manageUrl) {
    var $modal = $('#deletePaymentModal');

    $modal.find('.js-delete-payment-modal-title-default').addClass('d-none');
    $modal.find('.js-delete-payment-modal-title-in-use').removeClass('d-none');
    $modal.find('.js-delete-payment-modal-msg-default').addClass('d-none');
    $modal.find('.js-delete-payment-modal-msg-in-use').removeClass('d-none');
    $modal.find('.js-delete-payment-modal-confirm').addClass('d-none');
    $modal.find('.js-delete-payment-modal-subscription-link')
        .removeClass('d-none')
        .attr('href', manageUrl);
}

/**
 * Sets data and content for Modal
 * @param {Object} e Event object
 */
function deletePayment(e) {
    e.preventDefault();
    e.stopPropagation();
    var $trigger = $(e.currentTarget).closest('.delete-payment-btn');
    var target = $trigger.length ? $trigger[0] : e.currentTarget;
    var dataset = target.dataset;
    var subscriptionManageUrl = $trigger.attr('data-subscription-manage-url') || '';
    var paymentInfo = $('.payment-method[id="uuid-' + dataset['id'] + '"]').find('.card-info-group').html();

    if (subscriptionManageUrl) {
        setDeletePaymentModalInUseMode(subscriptionManageUrl);
    } else {
        resetDeletePaymentModal();
    }

    $('.product-to-remove').empty().append(paymentInfo);

    // jQuery .attr(name, undefined) stringifies to "undefined" and breaks JSON.parse on confirm
    var isRemoveAllowed = Object.prototype.hasOwnProperty.call(dataset, 'isRemoveAllowed')
        && dataset.isRemoveAllowed !== undefined
        && dataset.isRemoveAllowed !== ''
        ? dataset.isRemoveAllowed
        : 'true';
    var messageRemoveIsNotAllowed = dataset.messageRemoveIsNotAllowed || '';

    $('.remove-bt-payment')
        .attr('data-dismiss', 'modal')
        .attr('data-loader', dataset.loader)
        .attr('data-url', dataset.url)
        .attr('data-is-remove-allowed', isRemoveAllowed)
        .attr('data-message-remove-is-not-allowed', messageRemoveIsNotAllowed)
        .attr('data-id', dataset.id)
        .attr('data-card', dataset.card)
        .removeClass('paypal')
        .addClass('creditcard');

    if (!$('#deletePaymentModal').hasClass('show')) {
        $('#deletePaymentModal').modal('show');
    }
}

/**
 * Select default card in Credit/SRC Cards list
 * @param {Object} e Event object
 */
function makeDefaultCard(e) {
    var target = e.target;
    var url = target.getAttribute('data-make-default-url');
    var id = target.getAttribute('data-id');
    var paymentMethodID = 'CARD';

    // Hide "Credit Card error message" container
    errorHandlingBaseModel.hideError();
    creditCardListLoader.show();

    $.get(url + '?UUID=' + id + '&pmID=' + paymentMethodID)
        .then((data) => {
            // New default Card changes
            document.querySelector('#uuid-' + data.newDefaultProperty + ' span').style.fontWeight = 'bold';
            document.querySelector('.braintree-make-default-card.uuid-' + data.newDefaultProperty).style.display = 'none';

            // Previous default Card changes
            document.querySelector('#uuid-' + data.toRemoveDefaultProperty + ' span').style.fontWeight = 'normal';
            document.querySelector('.braintree-make-default-card.uuid-' + data.toRemoveDefaultProperty).style.display = 'inline';

            creditCardListLoader.hide();
        })
        .catch(function () {
            creditCardListLoader.hide();
        });
}

function initAccount() {
    var $creditCardAccountBtLoader = document.querySelector('#creditCardAccountBtLoader');
    var creditCardListLoaderExists = Boolean($creditCardAccountBtLoader);

    if (creditCardListLoaderExists) {
        creditCardListLoader = loaderInstance($creditCardAccountBtLoader);
    }
    // "Add new card" area link functionality initiation
    $('.braintreeAddNewCard').click(showAddNewCardOptions);

    // "Make default" link functionality initiation
    $('.creditCard-accounts').on('click', '.braintree-make-default-card', makeDefaultCard);

    // "Remove Card" link functionality initiation
    $('body').on('click', '.remove-bt-payment.creditcard', removeCard);

    $('body').on('click', '.js-delete-payment-modal-subscription-link', function (e) {
        var href = this.getAttribute('href');

        if (!href || href === '#') {
            e.preventDefault();
        }
    });

    // "Delete payment button modal opening" (Stripe + Braintree cards and PayPal)
    $('.payment-methods-list').on('click', '.delete-payment-btn', deletePayment);

    $('#deletePaymentModal').on('hidden.bs.modal', resetDeletePaymentModal);
}

module.exports = {
    initAccount
};
